import { render, staticRenderFns } from "./CaipanList.vue?vue&type=template&id=adae6aa0&scoped=true&"
import script from "./CaipanList.vue?vue&type=script&lang=js&"
export * from "./CaipanList.vue?vue&type=script&lang=js&"
import style0 from "./CaipanList.vue?vue&type=style&index=0&id=adae6aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adae6aa0",
  null
  
)

export default component.exports